var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',{class:( _obj = {
    'list': true,
    'vertical': _vm.props.hasOwnProperty('vertical') ? (_vm.props.vertical !== '' ? _vm.props.vertical : true) : false,
    'bold': _vm.props.hasOwnProperty('boldKey') ? (_vm.props.boldKey !== '' ? _vm.props.boldKey : true) : false,
    'row-spacing': _vm.props.hasOwnProperty('rowSpacing') ? (_vm.props.rowSpacing !== '' ? _vm.props.rowSpacing : true) : false
  }, _obj[_vm.data.staticClass] = !!_vm.data.staticClass, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }